import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class CryptionService {
  constructor() { }

  encryptUsingAES256(sample, key, iv) {
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(sample), CryptoJS.enc.Utf8.parse(key), {
      keySize: 128 / 8,
      iv: CryptoJS.enc.Utf8.parse(iv),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    //this.decryptUsingAES256(encrypted);
    return encrypted;
  }
}
